// @ts-nocheck
import componentsReducer, { StoreComponentsActions } from "@store/Framework/Store/Components/ComponentsReducer";
import dataReducer, { StoreDataActions } from "@store/Framework/Store/Data/DataReducer";
import pageReducer, { StorePagesActions } from "@store/Framework/Store/Pages/PagesReducer";
import { combineReducers } from "redux";

const storeReducers = {
    pages: pageReducer,
    components: componentsReducer,
    data: dataReducer,
};

export type StoreActions = StorePagesActions | StoreComponentsActions | StoreDataActions;
export default combineReducers(storeReducers);
